import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { LuUsers, LuUserPlus } from "react-icons/lu";
import { TbUserCog } from "react-icons/tb";
import { FaRegTrashAlt } from "react-icons/fa";

const BuyerLayout = () => {
  const location = useLocation();

  // Define paths for which <Outlet /> should NOT render
  const noPlaceholderPaths = ["/buyer/allactivebuyertable/buyernav"];

  return (
    <div>
        {/* Header Section */}
        <div className='p-[30px] border-b border-gray-200 w-full font-inter'>
          <h1 className="text-2xl  font-semibold text-[#667085]">Buyer</h1>
        </div>

        {/* Navigation Links */}
        <div>
        <div className="flex gap-10  mb-8 pt-10 border-b">
          <NavLink
            to="all-active-buyer"
            className={({ isActive }) =>
              isActive ||
              location.pathname === "/admind-ashboard/buyer" ||
              location.pathname.startsWith(
                "/admin-dashboard/buyer/all-active-buyer"
              )
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
          >
            <span>
              <LuUsers />
            </span>
            All Active Buyer
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
            to="add-buyer"
          >
            <span>
              <LuUserPlus />
            </span>
            Add Buyer
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
            to="buyersettings"
          >
            <span>
              <TbUserCog />
            </span>
            Buyer Settings
          </NavLink>
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex items-center gap-2 text-blood text-lg font-medium border-b-[3px] border-blood"
                : "flex items-center gap-2 text-[#667085] text-lg font-medium"
            }
            to="Buyer-trash"
          >
            <span>
              <FaRegTrashAlt />
            </span>
            Trash
          </NavLink>
        </div>

        {/* Render <Outlet /> conditionally */}
        <div>
          {!noPlaceholderPaths.some((path) =>
            location.pathname.includes(path)
          ) && <Outlet />}
        </div>
        </div>
    </div>
  );
};

export default BuyerLayout;
